export function createHealthSurvey(data = {}) {
  const survey = Object.assign(
    {
      student_name: "",
      gender: "",
      birth_year: "",
      skin_problem: "",
      skin_details: "",
      skin_contagious: "",
      body_aches: "",
      body_aches_details: "",
      diarrhea_vomiting: "",
      diarrhea_vomiting_details: "",
      eye_problems: "",
      eye_details: "",
      allergies_status: "",
      allergy_types: [],
      allergy_other: "",
      organ_problem: "",
      organ_types: [],
      organ_other: "",
      breathing_problem: "",
      breathing_details: "",
      blood_problem: "",
      blood_details: "",
      blood_contagious: "",
      fainting: "",
      fainting_details: "",
      injuries: "",
      injuries_details: "",
      mental_illness: "",
      mental_illness_details: "",
      daily_medicines: "",
      daily_medicines_details: "",
      other_problem: "",
      other_problem_details: "",
      no_physical_illness: false,
      declaration_student_name: "",
      parent_names: "",
      parent_print: "",
      parent_signature: "",
      student_print: "",
      student_signature: "",
      parent_date: "",
      student_date: "",
    },
    data || {}
  );
  survey.allergy_types = Array.isArray(survey.allergy_types) ? survey.allergy_types : [];
  survey.organ_types = Array.isArray(survey.organ_types) ? survey.organ_types : [];
  return survey;
}

export function createStudentProfile(data = {}) {
  const profile = Object.assign(
    {
      chinese_name: "",
      first_name: "",
      last_name: "",
      american_name: "",
      email: "",
      wechat_id: "",
      date_of_birth: "",
      gender: "",
      age: "",
      grade_entering: "",
      mother_name: "",
      father_name: "",
      parent_agent_email: "",
      parent_agent_wechat: "",
      hometown: "",
      school: "",
      english_level: "",
      host_children: "",
      host_relationship: "",
      smoke: "",
      animal_allergy: "",
      allergies: "",
      food_restrictions: "",
      medical_psychological_conditions: "",
      hobbies: "",
      personality: "",
      introduction: "",
      photos: [],
    },
    data || {}
  );
  profile.photos = Array.isArray(profile.photos) ? profile.photos : [];
  return profile;
}
